<template>
  <div class="dashboard-content">

    <!-- Super Bonus Progress Bar -->
    <div v-if="superBonus && superBonus.ranges
    && superBonus.ranges.length > 0" class="feature-box progress-bar-wrapper mb-4">
      <p class="super-bonus-title">Super Bonus program</p>
      <div class="progress-bar-container">
        <div class="progress-bar">
          <div
            class="current-amount-tooltip"
            :style="{ left: progressWidth + '%' }"
          >
            {{ formattedCurrentAmount() }}
          </div>
          <div
            class="progress-fill"
            :style="{ width: progressWidth + '%' }"
          ></div>
        </div>

        <div
          v-for="(milestone, index) in superBonus.ranges"
          :key="index"
          class="milestone"
          :style="{ left: calculateSuperbonusProgress(milestone.maxAmount) + '%' }"
        >
          <div
            class="milestone-circle"
            :class="{ 'active': progressPercentage
            >= calculateSuperbonusProgress(milestone.maxAmount) }"
          >
            {{ milestone.discount }}%
          </div>
          <div class="milestone-value">
            {{ milestone.maxAmount }}
          </div>
        </div>

      </div>
    </div>

    <div class="finance-info cta-simple cta-border" v-if="profile?.userData?.canViewFinances">
      <div class="finance-info-item">
        <p>{{ translations.approvedDebt }}:</p>
        <p><b>{{ financeInfo?.creditLimit?.toFixed(2).replace('.', ',') ?? '-' }}</b></p>
      </div>
      <div class="finance-info-item">
        <p>{{ translations.currentDebt }}:</p>
        <p :class="{ 'text-danger': financeInfo?.total > 0 }">
          <b>{{ financeInfo?.total?.toFixed(2).replace('.', ',') ?? '-' }}</b>
        </p>
      </div>
      <div class="finance-info-item">
        <p>{{ translations.debtOutsideCurrency }}:</p>
        <p :class="{ 'text-danger': financeInfo?.totalAfterDelay > 0 }">
          <b>{{ financeInfo?.totalAfterDelay?.toFixed(2).replace('.', ',') ?? '-' }}</b>
        </p>
      </div>
      <div class="finance-info-item">
        <p>{{ translations.paymentTerms }}:</p>
        <p><b>{{ financeInfo?.paymentDelay ?? '-' }} {{ translations.days }}</b></p>
      </div>
      <router-link class="btn btn-lg btn-primary" :to="{ name: 'ProfileFinance' }">
        {{ translations.viewFinances }}
      </router-link>
    </div>

    <div class="row row-lg" id="tab-box">
      <router-link class="col-6 col-md-3" :to="{ name: 'Orders' }">
        <div class="feature-box text-center pb-4">
          <div class="btn-link btn link-to-tab">
            <i class="sicon-social-dropbox"></i>
          </div>
          <div class="feature-box-content">
            <h3>{{ translations.orders }}</h3>
          </div>
        </div>
      </router-link>

      <router-link :to="{ name: 'Messages' }" class="col-6 col-md-3">
        <div class="feature-box text-center pb-4">
          <div class="btn-link btn link-to-tab position-relative">
            <i class="sicon-envelope"></i>
            <span
              class="badge text-light position-absolute translate-middle"
              v-if="unreadMessagesCount"
            >
              {{ unreadMessagesCount }}
            </span>
          </div>
          <div class="feature-box-content">
            <h3>{{ translations.messages }}</h3>
          </div>
        </div>
      </router-link>

      <router-link class="col-6 col-md-3" :to="{ name: 'Address' }">
        <div class="feature-box text-center pb-4">
          <div class="btn-link btn link-to-tab">
            <i class="sicon-location-pin"></i>
          </div>
          <div class="feature-box-content">
            <h3>{{ translations.addresses }}</h3>
          </div>
        </div>
      </router-link>

      <router-link class="col-6 col-md-3" :to="{ name: 'AccountDetails' }">
        <div class="feature-box text-center pb-4">
          <div class="btn-link btn link-to-tab">
            <i class="icon-user-2"></i>
          </div>
          <div class="feature-box-content">
            <h3>{{ translations.accountDetails }}</h3>
          </div>
        </div>
      </router-link>

      <router-link class="col-6 col-md-3" :to="{ name: 'RMA' }">
        <div class="feature-box text-center pb-4">
          <div class="btn-link btn link-to-tab">
            <i class="sicon-note"></i>
          </div>
          <div class="feature-box-content">
            <h3>{{ translations.rmaForm }}</h3>
          </div>
        </div>
      </router-link>

      <router-link class="col-6 col-md-3"
      :to="{ name: 'ProfileFinance' }" v-if="profile?.userData?.canViewFinances">
        <div class="feature-box text-center pb-4">
          <div>
            <i class="icon-secure-payment" />
          </div>
          <div class="feature-box-content">
            <h3>{{ translations.finances }}</h3>
          </div>
        </div>
      </router-link>

      <router-link class="col-6 col-md-3" :to="{ name: 'MyFiles' }">
        <div class="feature-box text-center pb-4">
          <div>
            <i class="sicon-folder-alt" />
          </div>
          <div class="feature-box-content">
            <h3>{{ translations.myFiles }}</h3>
          </div>
        </div>
      </router-link>

      <router-link class="col-6 col-md-3" :to="{ name: 'Wishlist' }">
        <div class="feature-box text-center pb-4">
          <div>
            <i class="sicon-heart" />
          </div>
          <div class="feature-box-content">
            <h3>{{ translations.wishlist }}</h3>
          </div>
        </div>
      </router-link>

      <router-link class="col-6 col-md-3" :to="{ name: 'ShoppingCards' }">
        <div class="feature-box text-center pb-4">
          <div>
            <i class="sicon-basket-loaded" />
          </div>
          <div class="feature-box-content">
            <h3>{{ translations.shoppingCarts }}</h3>
          </div>
        </div>
      </router-link>
    </div>

  </div>
</template>

<script>
import { translations } from '@/mixins';

export default {
  name: 'Dashboard',
  mixins: [translations],
  data() {
    return {
      finishedMounted: false,
    };
  },
  computed: {
    progressWidth() {
      return this.progressPercentage;
    },
    progressPercentage() {
      return this.calculateSuperbonusProgress(this.superBonus?.totalAmount ?? 0);
    },
    profile() {
      return this.$store.getters.getProfile;
    },
    financeInfo() {
      return this.$store.getters.getFinanceInfo;
    },
    unreadMessagesCount() {
      return this.$store.getters.getUnreadMessagesCount;
    },
    superBonus() {
      const data = this.$store.getters.getSuperBonusByCompany;
      if (
        !this.finishedMounted
        && data
        && data.ranges
        && Array.isArray(data.ranges)
      ) {
        data.ranges.forEach((item, index) => {
          const generatedId = this.generateRandomId();
          this.$set(data.ranges, index, { ...item, generatedId });
        });
      }
      return data;
    },
    lastMaxAmount() {
      if (!this.superBonus?.ranges?.length) return 0;
      return this.superBonus.ranges[this.superBonus.ranges.length - 1].maxAmount;
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.$store.dispatch('getUnreadMessagesCount');
    this.$store.dispatch('getSuperBonusByCompany', this.profile.userData.companyId)
      .then(() => {
        this.finishedMounted = true;
      });
  },
  methods: {
    setActiveComponent(component) {
      this.$emit('changeTab', component);
    },
    calculateSuperbonusProgress(amount) {
      if (!this.lastMaxAmount) return 0;
      if (amount === this.lastMaxAmount) return 100;
      return (amount / this.lastMaxAmount) * 100;
    },
    formattedCurrentAmount() {
      const val = this.superBonus?.totalAmount ?? 0;
      return val >= 1000
        ? `${(val / 1000).toFixed(1).replace('.', ',')}k`
        : `${val.toFixed(2).replace('.', ',')}`;
    },
    generateRandomId() {
      return -Math.ceil(Math.random() * 1000000);
    },
  },
};
</script>

<style lang="scss" scoped>
.badge {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: #ed7e63;
  height: 2rem;
  width: 2rem;
  border-radius: 50%;
  top: -43px;
  right: -6px;
}

.super-bonus-title {
  font-size: 12px;
  font-weight: 700;
}

.progress-bar-wrapper {
  padding: 16px 20px 12px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #ebebeb;
}

.progress-bar-container {
  position: relative;
  height: 75px;
  margin-bottom: 0;
}

.progress-bar {
  height: 20px;
  background-color: #e5e5e5;
  border-radius: 2px;
  position: absolute;
  top: 15px;
  left: 0;
  right: 0;
}

.progress-fill {
  height: 100%;
  background-color: #007bff;
  border-radius: 2px;
  position: absolute;
  top: 0;
  left: 0;
  transition: width 0.3s ease;
}

.current-amount-tooltip {
  position: absolute;
  top: -10px;
  transform: translateX(-50%);
  background: #1c3254;
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 3;
}

.milestone {
  position: absolute;
  top: 0;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.milestone-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #e8e8e8;
  border: none;
  box-shadow: none;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
  color: #aaaaaa;
  position: relative;
  z-index: 2;
  transition: background 0.3s ease, color 0.3s ease;
}

.milestone-circle.active {
  background: #1c3254;
  color: #ffffff;
  box-shadow: none;
}

.milestone-value {
  margin-top: 5px;
  font-size: 12px;
  font-weight: 600;
  color: #555;
}

.credit-usage-label {
  text-align: center;
  font-size: 13px;
  color: #777;
  margin-top: 10px;
}
</style>
